module.exports = __webpack_public_path__ + "img/downSolid.57d56ef0.svg";